// extracted by mini-css-extract-plugin
export default {"loader":"HistoryPage_loader__hYJZn"};